import { RootState } from '../store';

export const selectCreditCardReducer = ({ creditCardReducer }: RootState) => creditCardReducer;
